export default __webpack_public_path__ + "static/3-db5085dcc9bda0c072dc1dbd8f06e88b.gif";